import { render, staticRenderFns } from "./RadialBar.md?vue&type=template&id=badcc0b0&"
import script from "./RadialBar.md?vue&type=script&lang=js&"
export * from "./RadialBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badcc0b0')) {
      api.createRecord('badcc0b0', component.options)
    } else {
      api.reload('badcc0b0', component.options)
    }
    module.hot.accept("./RadialBar.md?vue&type=template&id=badcc0b0&", function () {
      api.rerender('badcc0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/RadialBar.md"
export default component.exports